export default __webpack_public_path__ + "static/media/gift-card.72970e24.svg";